import { useQuery } from '@tanstack/react-query';

import { listUserEmailLogs } from '~/services/AgentHub/AgentService';

const FIVE_MINUTES = 5 * 60 * 1000;

interface UseListUserEmailLogsParams {
  agentId: string | undefined;
  page: number;
  pageSize: number;
}

export function useListUserEmailLogs({ agentId, page, pageSize }: UseListUserEmailLogsParams) {
  return useQuery({
    queryKey: ['user-email-logs', agentId, page, pageSize],
    queryFn: async () => {
      return await listUserEmailLogs(agentId, {
        type: 'activation',
        page: page.toString(),
        pageSize: pageSize.toString(),
      });
    },
    enabled: !!agentId,
    staleTime: FIVE_MINUTES,
  });
}
